import styled from "styled-components";
import { Paragraph } from "../../atoms/Typography/Typography.styles";

export const AuthenticationHandler = styled.div`
  min-height: 100svh;
`

export const AuthenticationForm = styled.form``

export const AuthenticationFormInputWrapper = styled.div``

export const AuthenticationFormInput = styled.input``

export const AuthenticationFormError = styled.div`
  text-align: center;
  
  ${Paragraph} {
    color: ${({ theme }) => theme.colors.status.error.default};
  }
`